import { render } from "./video.vue?vue&type=template&id=4f093652&scoped=true&ts=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"

import "./video.vue?vue&type=style&index=0&id=4f093652&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f093652"]])

export default __exports__